import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconDoubleDiamondFilled(props: IconProps) {
	return (
		<Icon fill="currentColor" {...props} viewBox="0 0 24 25">
			<path
				fill="currentColor"
				d="M10 2a2.45 2.45 0 0 1 1.262.349l-.021.027-5.36 6.893c-.61.778-.88 1.78-.88 2.726 0 .947.27 1.95.878 2.73l5.367 6.901.016.021q-.074.045-.153.085a2.46 2.46 0 0 1-3.066-.709l-5.375-6.91c-.89-1.145-.89-3.092 0-4.228L8.03 2.99A2.46 2.46 0 0 1 10 2"
			/>
			<path
				fill="currentColor"
				d="M14 2a2.45 2.45 0 0 1 1.959.974l5.375 6.91c.89 1.145.89 3.092 0 4.228l-5.362 6.894a2.457 2.457 0 0 1-3.93.017l-5.374-6.91c-.89-1.145-.89-3.092 0-4.228L12.03 2.99A2.46 2.46 0 0 1 14 2"
			/>
		</Icon>
	);
}
